<template>
  <CModal
    :title="title"
    :color="color"
    :show.sync="showModal"    
    class="basic-modal-color"
  >   
    <CForm id="event_planner_form" method="POST" enctype="multipart/form-data">     
      <CInput
        hidden
        :lazy="false"
        :value.sync="$v.form.id.$model"
        name="id"
        id="id"          
      />       
      <CRow>              
        <CCol md="6">
          <CInput
            label="Nombre:"
            :lazy="false"
            :value.sync="$v.form.name.$model"
            name="name"
            id="name"
            placeholder=""
          />
        </CCol>    
        <CCol md="6">
          <CInput
            label="Telefono:"
            :lazy="false"
            :value.sync="$v.form.phone.$model"
            name="phone"
            id="phone"
            type="text"
            placeholder=""
          />
        </CCol>    
      </CRow>            
    </CForm>
    <template #footer>
      <CButton @click="closeModal" color="secondary">Cancelar</CButton>
      <CButton @click="store" :color="color">Guardar</CButton>
    </template>
  </CModal>
</template>

<script>
import { validationMixin } from "vuelidate"
import { required, minValue } from "vuelidate/lib/validators"
import store from '../../store';
import ws from '../../services/events_planners';

export default {
  name: 'EventPlannerModal',
  props: {
  },
  components: {
  },
  data () {
    return {
      showModal: false,
      title: "Editar Organizador",
      color: "info",
      isEdit: false,
      form: this.getEmptyForm(),
      submitted: false,      
    }
  },
  mounted: async function() {    
    
  },
  methods: {
    async updateModal () {
      this.showModal = true;
      this.color = "success";
      this.title = 'Editar Organizador';
      this.isEdit = true;
      this.submitted = false;

      let response_planner = await ws.get();
      if(response_planner.type == "success"){
        this.form = {
          id: response_planner.data.id,
          name: response_planner.data.name,
          phone: response_planner.data.phone,
        };
      }        
    },
    async store () {
      this.$v.$touch();

      if (this.isValid) {
        this.loading();
        this.submitted = true;

        let form = document.getElementById("event_planner_form");
        let formData = new FormData(form);
        let response = "";
        response = await ws.update(formData);         
        this.loaded();
        this.showToast(response.type, response.message);
        if(response.type == "success"){
          this.closeModal();
        }                              
      }
    },
    closeModal () {
      this.showModal = false;

      this.form = this.getEmptyForm()
      this.submitted = false
      this.$v.$reset()
    },
    getEmptyForm () {
      return {
          id: 0,
          name: '',
          phone: '',
      }
    },
    checkIfValid (fieldName) {
      const field = this.$v.form[fieldName]
      if (!field.$dirty) {
        return null
      }
      
      return !(field.$invalid || field.$model === '')
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  },
  computed: {
    formString () { return JSON.stringify(this.form, null, 4) },
    isValid () { return !this.$v.form.$invalid },
    isDirty () { return this.$v.form.$anyDirty },
  },
  mixins: [validationMixin],
  validations: {
    form: {
      id: {        
      },
      name: {        
      },
      phone: {
      },
      
    }
  },
}
</script>
<style>
.basic-modal-color .modal-header{
  background-color: #668269 !important;
}
</style>